import React from 'react';
import {constants} from "../../constant/constants";
import useUserStore from "../../stores/store";
import Dashboard from "../images/Dashboard";
import Category from "../images/Category";
import Food from "../images/Food";
import Payments from "../images/Payments";
import Staff from "../images/Staff";
import Restaurants from "../images/Restaurants";
import Groups from "../images/Groups";
import Users from "../images/Users";
import TableImage from '../images/TableImage';


function SideMenu ({title, menu}) {
    const { user, role, inventoryType } = useUserStore();
    let isAdmin = role === "Admin" || false
    
    return (
        <div className="flex flex-col w-[80px] fixed top-[80px] left-0 right-0 bg-yellowopac p-[16px] items-center h-screen">
            <div className="flex flex-col justify-center mt-[48px]">
                {!user?.isSuperAdmin?<Dashboard
                    url={constants.MENU.DASHBOARD.toLowerCase()}
                    color={menu===constants.MENU.DASHBOARD?"#EE3169":"#111111"}
                    classes={`my-[12px] p-[16px] rounded-[24px] cursor-pointer ${menu===constants.MENU.DASHBOARD?"bg-orange":""}`}/>:''}
                {isAdmin?<Category
                    url={constants.MENU.CATEGORY.toLowerCase()}
                    color={menu===constants.MENU.CATEGORY?"#EE3169":"#111111"}
                    classes={`my-[12px] p-[16px] rounded-[24px] cursor-pointer ${menu===constants.MENU.CATEGORY?"bg-orange":""}`}/>:''}
                {!user?.isSuperAdmin && inventoryType === 'ITEM'?<Food
                    url={constants.MENU.FOOD.toLowerCase()}
                    color={menu===constants.MENU.FOOD?"#EE3169":"#111111"}
                    classes={`my-[12px] p-[16px] rounded-[24px] cursor-pointer ${menu===constants.MENU.FOOD?"bg-orange":""}`}/>:''}
                {!user?.isSuperAdmin?<Payments
                    url={constants.MENU.ORDER.toLowerCase()}
                    color={menu===constants.MENU.ORDER?"#EE3169":"#111111"}
                    classes={`my-[12px] p-[16px] rounded-[24px] cursor-pointer ${menu===constants.MENU.ORDER?"bg-orange":""}`}/>:''}
                {isAdmin?<TableImage
                    url={constants.MENU.TABLE.toLowerCase()}
                    color={menu===constants.MENU.TABLE?"#EE3169":"#111111"}
                    classes={`my-[12px] p-[16px] rounded-full flex items-center cursor-pointer ${menu===constants.MENU.TABLE?"bg-orange":""}`}/>:''}
                {isAdmin?<Staff
                    url={constants.MENU.STAFF.toLowerCase()}
                    color={menu===constants.MENU.STAFF?"#EE3169":"#111111"}
                    classes={`my-[12px] p-[16px] rounded-[24px] cursor-pointer ${menu===constants.MENU.STAFF?"bg-orange":""}`}/>:''}
                {user?.isSuperAdmin?<Restaurants
                    url={constants.SUPER_MENU.RESTAURANT.toLowerCase()}
                    color={menu===constants.SUPER_MENU.RESTAURANT?"#EE3169":"#111111"}
                    classes={`my-[12px] p-[16px] rounded-[24px] cursor-pointer ${menu===constants.SUPER_MENU.RESTAURANT?"bg-orange":""}`}/>:''}
                {user?.isSuperAdmin?<Groups
                    url={constants.SUPER_MENU.USER.toLowerCase()}
                    color={menu===constants.SUPER_MENU.USER?"#EE3169":"#111111"}
                    classes={`my-[12px] p-[16px] rounded-[24px] cursor-pointer ${menu===constants.SUPER_MENU.USER?"bg-orange":""}`}/>:''}
                {user?.isSuperAdmin?<Users
                    url={constants.SUPER_MENU.GROUP.toLowerCase()}
                    color={menu===constants.SUPER_MENU.GROUP?"#EE3169":"#111111"}
                    classes={`my-[12px] p-[16px] rounded-[24px] cursor-pointer ${menu===constants.SUPER_MENU.GROUP?"bg-orange":""}`}/>:''}
            </div>
            
      {/* <FcmInitComponent /> */}
        </div>
    );
}

export default SideMenu;
